import gql from 'graphql-tag';

export default gql`
  mutation createOneCopyLessonMutation(
    $lessonId: MongoID!
    $beforeLessonId: MongoID
    $courseCategory: MongoID
    $lessonTemplate: MongoID
    $courseId: MongoID
    $videoCallStatus: String
    $isZeroLesson: Boolean
    $student: MongoID
  ) {
    createOneCopyLessonMutation(
      lessonId: $lessonId
      beforeLessonId: $beforeLessonId
      courseCategory: $courseCategory
      lessonTemplate: $lessonTemplate
      courseId: $courseId
      videoCallStatus: $videoCallStatus
      isZeroLesson: $isZeroLesson
      student: $student
    ) {

      record {
        _id
        id
      }
    }
  }
`;
